import { Grid } from "@mui/material";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { isLenderRole, isProjectRole, isProjectStandardRole, isReadonlyRole, isTPORole } from "../../redux/actions/userAction";
import AttachmentsPage from "./Pages/AttachmentsPage";
import SuccessPage from "../SuccessPage/SuccessPage";
import VerticalLinearStepper from "../VerticalLinearStepper/VerticalLinearStepper";
import { EditFieldsPage } from "./Pages/EditFieldsPage";
import ProjectInfoBanner from "../SharedComponents/ProjectInfoBanner/ProjectInfoBanner";
import { REQUEST_TYPES } from "../shared/constants/RequestTypes";
import "./EditProject.css";


export const EditProject = (props) => {
  if((!isProjectStandardRole() && !isLenderRole() && !isTPORole()) || isReadonlyRole()) {    
     location.replace("/unauthorized");
     return null;
  }

  const [projectType, setProjectType] = useState();
  const [projectInfo, setProjectInfo] = useState();
  const [stepCount, setStepCount] = useState(0);

  const steps = useMemo(() => {
    const steps = [
      "Edit Project Details",
      "Final Confirmation"
    ];

    if (!isProjectRole()) {
      steps.splice(1, 0, "Attach Documents");
    }

    return steps;
  }, []);

  const incrementCounter = () => setStepCount(stepCount + 1);
  const decrementCounter = () => setStepCount(stepCount - 1);

  const projectId = props.match.params.project_id;
  
  useEffect(() => {
    setStepCount(0);
    
    (async () => {
      const projectInfo = await getProjectDetailsById(projectId);
      setProjectInfo(projectInfo);
      setProjectType(projectInfo?.newProjectType);
    })();
  }, []);

  async function getProjectDetailsById(projectId) {
    const projectJson = localStorage.getItem("project" + [projectId]);
    if (projectJson) {
      const projectInfo = JSON.parse(projectJson);
      console.log("Project info from localStorage:", projectInfo);
      return projectInfo;
    }

    const { data: project } = await axios.get(
      global.REACT_APP_API_ENDPOINT +
      `/condoMgr/getProjectDetailsByProjectId/` +
      projectId
    );

    if (project === `Cannot find project:${projectId}`) {
      console.error(project);
      return;
    }

    return project.projectProfile;
  }

  const userRole = sessionStorage.getItem('role');

  const getPage = () => {
    if (!stepCount) {
      return (
        <EditFieldsPage
          incrementCounter={incrementCounter}
          projectInfo={projectInfo}
          stepCount={steps.length || 2}
        />
      );
    }
    
    if (stepCount === 1 && !isProjectRole()) {
      return (
        <AttachmentsPage
          incrementCounter={incrementCounter}
          decrementCounter={decrementCounter}
        />
      );
    }

    if (projectId) {
      return (
        <>
          <SuccessPage
            project_id={projectId}
            project_type={projectType}
            requestTypeName={REQUEST_TYPES.LENDER_EDIT_PROJECT}
            msg={isProjectRole() 
              ? `Project ${projectId} was successfully updated!` 
              : `A change to project ${projectId} was succesfully requested!`}
          />
        </>
      );
    }
      
    return "Empty name";
  };

  return (
    <Grid className="add-new-project" container>
      <Grid item xs={3} style={{ backgroundColor: "#F2F2F2" }}>
        <VerticalLinearStepper
          steps={steps}
          activeStep={stepCount}
        />
      </Grid>
      <Grid
        container
        item
        xs={9}
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        style={{ padding: "20px", border: "solid 1px black" }}
      >
        <ProjectInfoBanner projectId={projectId} projectName={projectInfo?.projectName} />
        {getPage()}
      </Grid>
    </Grid>
  );
};